var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 5.29904C15.5235 4.85246 16.4765 4.85246 17.25 5.29904L24.6423 9.56699C25.4158 10.0136 25.8923 10.8389 25.8923 11.7321V20.2679C25.8923 21.1611 25.4158 21.9864 24.6423 22.433L17.25 26.701C16.4765 27.1475 15.5235 27.1475 14.75 26.701L7.3577 22.433C6.58419 21.9864 6.1077 21.1611 6.1077 20.268V11.7321C6.1077 10.8389 6.58419 10.0136 7.3577 9.56699L14.75 5.29904Z",
    stroke: "#9A9BA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 22,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 5.29904C15.5235 4.85246 16.4765 4.85246 17.25 5.29904L24.6423 9.56699C25.4158 10.0136 25.8923 10.8389 25.8923 11.7321V20.2679C25.8923 21.1611 25.4158 21.9864 24.6423 22.433L17.25 26.701C16.4765 27.1475 15.5235 27.1475 14.75 26.701L7.3577 22.433C6.58419 21.9864 6.1077 21.1611 6.1077 20.268V11.7321C6.1077 10.8389 6.58419 10.0136 7.3577 9.56699L14.75 5.29904Z",
    fill: "#D9D9D9",
    stroke: "#9A9BA5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_483)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.9999,
    cy: 13,
    r: 2.92857,
    stroke: "#9A9BA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24.5714C8.5 20.9816 11.4101 18.0714 15 18.0714H17C20.5899 18.0714 23.5 20.9816 23.5 24.5714V25C23.5 26.933 21.933 28.5 20 28.5H12C10.067 28.5 8.5 26.933 8.5 25V24.5714Z",
    stroke: "#9A9BA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.cc24cb737b7efc25e99b8d6fe48fb3f5.svg";
export { ForwardRef as ReactComponent };